import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import makeStyles from '@mui/styles/makeStyles';
import { useCurrentUser } from '../CurrentUserContext';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const SnackbarContext = createContext();

export const SnackbarProvider = (props) => {
  const classes = useStyles();

  const [snack, setSnack] = useState({
    open: false,
    message: null,
    severity: null,
  });

  const { currentUser, refreshProvider } = useCurrentUser();
  const [showDownloadLimitSnack, setShowDownloadLimitSnack] = useState(false);

  useEffect(() => {
    const downloadMessage = currentUser?.downloadMessage;
    if (downloadMessage && showDownloadLimitSnack) {
      setSnack({ open: true, message: downloadMessage, severity: 'success' });
      setShowDownloadLimitSnack(false);
    }
  }, [currentUser]);

  const flashDownloadLimitSnack = useCallback(() => {
    refreshProvider();
    setShowDownloadLimitSnack(true);
  }, [refreshProvider, setShowDownloadLimitSnack]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnack({ ...snack, open: false });
  };

  const autoHide = snack.disableHide ? null : 6000;
  const origin = { vertical: 'bottom', horizontal: 'right' };
  const action = snack.action ? (
    <Button color="secondary" size="small" onClick={snack.action?.onClick}>
      {snack.action?.title}
    </Button>
  ) : undefined;
  return (
    <SnackbarContext.Provider value={{ setSnack, flashDownloadLimitSnack }}>
      {props.children}
      <div className={classes.root}>
        <Snackbar
          open={snack.open}
          autoHideDuration={autoHide}
          onClose={handleClose}
          anchorOrigin={origin}
          action={action}
        >
          {/* Div is needed here: https://github.com/mui/material-ui/issues/28918#issuecomment-1106820571 */}
          <div>
            <Alert onClose={handleClose} severity={snack.severity}>
              {snack.message}
              {action}
            </Alert>
          </div>
        </Snackbar>
      </div>
    </SnackbarContext.Provider>
  );
};

export const useSnackBarContext = () => useContext(SnackbarContext);

export const SnackbarConsumer = SnackbarContext.Consumer;

export default SnackbarContext;
